import axios from "axios";
import { xAPIKey, lappURL } from "./Config"


export const getLeadByPhone = (payload) => {
    return axios.post(`${lappURL}&type=getLeadByPhone`, payload, {
        headers: {
            "Content-Type": "application/json",
            "x-api-key": xAPIKey,
        },
    }).catch(err => console.log(err))
}
export const createOrUpdateLead = (payload) => {
    return axios.post(`${lappURL}&type=CreateOrUpdateLead`, payload, {
        headers: {
            "Content-Type": "application/json",
            "x-api-key": xAPIKey,
        },
    }).catch(err => console.log(err))
}
export const searchLead = (payload) => {
    return axios.post(`${lappURL}&type=searchLead`, payload, {
        headers: {
            "Content-Type": "application/json",
            "x-api-key": xAPIKey,
        },
    }).catch(err => console.log(err))
}

export const postActivityOnLead = (payload) => {
    return axios.post(`${lappURL}&type=postActivityOnLead`, payload, {
        headers: {
            "Content-Type": "application/json",
            "x-api-key": xAPIKey,
        },
    }).catch(err => console.log(err))
}

export const checkAuth = (payload) => {
    return axios.post(`${lappURL}&type=mavisCheck`, payload, {
        headers: {
            "Content-Type": "application/json",
            "x-api-key": xAPIKey,
        },
    }).catch(err => console.log(err))
}

export const getUserByEmail = (payload) => {
    return axios.post(`${lappURL}&type=getUserByEmail`, payload, {
        headers: {
            "Content-Type": "application/json",
            "x-api-key": xAPIKey,
        },
    }).catch(err => console.log(err))
}

export const preSubmission = (payload) => {
    return axios.post(`${lappURL}&type=preSubmission`, payload, {
        headers: {
            "Content-Type": "application/json",
            "x-api-key": xAPIKey,
        },
    }).catch(err => console.log(err))
}